import React from 'react';
import { Hero } from '../components/Hero';
import { TrustStrip } from '../components/TrustStrip';
import { ServiceCard } from '../components/ServiceCard';
import { WhoWeServe } from '../components/WhoWeServe';
import { ExpandedServices } from '../components/ExpandedServices';
import { HowItWorks } from '../components/HowItWorks';
import { VisualBreak } from '../components/VisualBreak';
import { GraphicDesignSection } from '../components/GraphicDesignSection';
import { LocalSEO } from '../components/LocalSEO';
import { CTASection } from '../components/CTASection';
import { Printer, Shirt, Palette, Film, Flame, Zap, Sparkles, Package, Gem, Flag, CreditCard, Layers } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
export function Home() {
  const coreServices = [{
    title: 'Screen Printing',
    description: 'High-volume custom screen printing for t-shirts, hoodies, and apparel. Perfect for teams, events, and businesses nationwide.',
    icon: <Printer data-id="element-975" />,
    accentColor: 'yellow' as const,
    link: '/services/screen-printing'
  }, {
    title: 'Award Winning Embroidery',
    description: 'Professional embroidery services adding a premium touch to polos, hats, jackets, and corporate wear for customers across the U.S.',
    icon: <Shirt data-id="element-976" />,
    accentColor: 'teal' as const,
    link: '/services/embroidery'
  }, {
    title: 'Direct to Film',
    description: 'Advanced DTF printing technology for vibrant, durable designs on any fabric type. Perfect for detailed artwork.',
    icon: <Film data-id="element-977" />,
    accentColor: 'pink' as const,
    link: '/services/direct-to-film'
  }, {
    title: 'Laser Engraving',
    description: 'Precision laser engraving for businesses nationwide. Perfect for awards, promotional items, and personalized gifts.',
    icon: <Zap data-id="element-978" />,
    accentColor: 'yellow' as const,
    link: '/services/laser-engraving'
  }, {
    title: 'Direct to Garment',
    description: 'Full-color, photo-quality prints for businesses nationwide. Ideal for detailed designs and small batch orders.',
    icon: <Printer data-id="element-979" />,
    accentColor: 'teal' as const,
    link: '/services/direct-to-garment'
  }, {
    title: 'Laser Etching',
    description: 'Precision laser etching services for unique, tone-on-tone branding on fleece, leather, and technical fabrics.',
    icon: <Zap data-id="element-980" />,
    accentColor: 'pink' as const,
    link: '/services/laser-etching'
  }, {
    title: 'Graphic Design',
    description: 'Professional graphic design services to create or refine your artwork. We convert ideas to print-ready vector art.',
    icon: <Sparkles data-id="element-981" />,
    accentColor: 'yellow' as const,
    link: '/services/graphic-design'
  }, {
    title: 'Heat Transfer',
    description: 'Custom heat transfer printing for names, numbers, and designs. Ideal for sports teams and personalized apparel.',
    icon: <Flame data-id="element-982" />,
    accentColor: 'teal' as const,
    link: '/services/heat-transfer'
  }, {
    title: 'Promotional Products',
    description: 'Custom promotional items for customers across the U.S. From pens to tote bags, we help you make a lasting impression.',
    icon: <Package data-id="element-983" />,
    accentColor: 'pink' as const,
    link: '/services/promotional-products'
  }, {
    title: 'Personalized Products',
    description: 'Custom personalized gifts and products for any occasion. From single items to bulk orders.',
    icon: <Gem data-id="element-984" />,
    accentColor: 'yellow' as const,
    link: '/services/personalized-products'
  }, {
    title: 'Banners',
    description: 'Indoor and outdoor banners for events, promotions, and displays. Durable and eye-catching.',
    icon: <Flag data-id="element-985" />,
    accentColor: 'teal' as const,
    link: '/services/banners'
  }, {
    title: 'Business Cards & Labels',
    description: 'Professional business cards and custom product labels. Make a lasting first impression.',
    icon: <CreditCard data-id="element-986" />,
    accentColor: 'pink' as const,
    link: '/services/business-cards'
  }];
  return <div className="flex flex-col w-full" data-id="element-987">
      {/* 1. Hero Section - LOCKED */}
      <Hero data-id="element-988" />

      {/* 2. Trust/Authority Strip */}
      <TrustStrip data-id="element-989" />

      {/* 3. Core Services Overview */}
      <section className="py-24 bg-white" data-id="element-990">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-991">
          <div className="text-center mb-16" data-id="element-992">
            <span className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-3" data-id="element-993">
              What We Do
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-994">
              Our Core Services
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-995">
              From screen printing to laser engraving, we offer a complete range
              of customization services to bring your vision to life.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-996">
            {coreServices.map((service, index) => <Link key={index} to={service.link} data-id="element-997">
                <ServiceCard {...service} data-id="element-998" />
              </Link>)}
          </div>

          <div className="text-center" data-id="element-999">
            <Link to="/services" data-id="element-1000">
              <Button variant="outline" size="lg" data-id="element-1001">
                View All Services
              </Button>
            </Link>
            <p className="text-sm text-gray-500 mt-3" data-id="element-1002">
              Everything you need, handled in-house from start to finish.
            </p>
          </div>
        </div>
      </section>

      {/* 4. Who We Serve */}
      <WhoWeServe data-id="element-1003" />

      {/* 5. Expanded Services */}
      <ExpandedServices data-id="element-1004" />

      {/* 6. How It Works */}
      <HowItWorks data-id="element-1005" />

      {/* 7. Visual Break - Full Width Scroll Hook */}
      <VisualBreak data-id="element-1006" />

      {/* 8. Graphic Design Support */}
      <GraphicDesignSection data-id="element-1007" />

      {/* 9. Local SEO Section */}
      <LocalSEO data-id="element-1008" />

      {/* 10. Final Conversion CTA */}
      <CTASection data-id="element-1009" />
    </div>;
}